module.exports = __webpack_public_path__ + "iPhone_6_7_8_plus.svg?1c933bde6f5a6c1dfb0d4c8610fab4fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_6_7_8_plus.svg
// module id = 228
// module chunks = 0